
<div class="row">
    <div class='col-md-3'></div>
    <div class='col-md-6 text-center'>
        <fa-icon [icon]="faCompass" class="fa-10x" style="color: #0055A4;"></fa-icon>
        <h1>Hey, this page doesn’t exist...</h1>
        <button  mat-raised-button routerLink="/"  class="m-2">Return to home</button>
    </div>
    <div class='col-md-3'></div>
</div>